import { CreateEnrolementInput, IUploadInvoice } from './enrole.interface';

export class GetEnrolementForms {
    static readonly type = '[enrolement] all ';
}

export class CreateEnrolement {
    static readonly type = '[enrolement] create';
    constructor(public input: CreateEnrolementInput) {}
}

export class GetUsereEnrolementForm {
    static readonly type = '[enrolement] user';
    constructor(public userId: string) {}
}

export class GetSingleEnrolementForm {
    static readonly type = '[enrolement] single';
    constructor(public id: string) {}
}

export class UploadEnrolementInvoice {
    static readonly type = '[enrolement] upload invoice';
    constructor(
        public input: {
            employeeName: string;
            invoicesBase64: string[];
        }
    ) {}
}

export class SubmitEnrolementInvoice {
    static readonly type = '[enrolement] submit invoice';
    constructor(public input: IUploadInvoice) {}
}
export class GetAllEnrolementInvoices {
    static readonly type = '[enrolement] get all invoice';
}
export class GetSingleEnrolementInvoices {
    static readonly type = '[enrolement] single invoice';
    constructor(public id: string) {}
}
